import React from 'react'
import HeadlinesPicker from '../HeadlinesPicker'

import editorStyles from '../editor.module.css'

const HeadlinesButton = props => {
  const onClick = () => props.onOverrideContent(HeadlinesPicker)

  return (
    <div className={editorStyles.headlineButtonWrapper}>
      <button onClick={onClick} className={editorStyles.headlineButton}>
        H
      </button>
    </div>
  )
}

export default HeadlinesButton
